import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './RecordIconScroll.module.css';
import ImageWithFallback from '../GenericComponents/ImageWithFallback';
import { getImages } from '../Result/getImages';

interface RecordIconScrollProps {
    record: any;
    index: number;
    handleLinkClick: (event: React.MouseEvent, index: number) => void;
}

const RecordIconScroll: React.FC<RecordIconScrollProps> = React.memo(({ record, index, handleLinkClick }) => {
    const { t } = useTranslation();
    const [isHovered, setIsHovered] = useState(false);

    let imageUrl = ""; //todo: noimage
    const allImages = getImages(record);
    if ((allImages as any)["iconscroll"]?.length > 0) {
        imageUrl = (allImages as any)["iconscroll"][0]?.url;
    }
    //console.log(imageUrl)
    //const recordNumber = record?.metadata?.recordnumber;
    const invNo = record?.data?.Record?.ObjectNumber;
    const [hasBeenShown, setHasBeenShown] = useState(false);
    const iconRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!hasBeenShown && iconRef.current) {
            //console.log('X');
            setTimeout(() => {
                iconRef.current?.classList.add(styles.fadeIn);
                setHasBeenShown(true); // Set the state to true after the icon has been shown
            }, 50);
        }
    }, [hasBeenShown]);

    function getTitle(record: any) {
        const titleData = record?.data?.record?.title?.title;

        if (!titleData) return <div className={styles.row}>{t('No title')}</div>;

        return (
            <div className={styles.row}>
                {titleData}
            </div>
        );
    }

    return (
        <div key={index}>
            <a
                href={`${window.location.pathname}?action=search&field=/Record/ObjectNumber&label=N°%20de%20gestion&value=${invNo}`}
                className={styles.RecordIcon}
                key={index}
                onClick={(event) => handleLinkClick(event, index)}
                onMouseDown={e => e.preventDefault()}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <div className={styles.iconViewRecord}>
                    {imageUrl && <ImageWithFallback src={imageUrl} alt="Image" placeholder={`${process.env.REACT_APP_IMAGE_BASE_URL}/nondisponible.cci&width=180`} />}

                    {isHovered && (
                        <div className={styles.hoverOverlay}>
                            <div className={styles.title}>{getTitle(record)}</div>
                            {record?.data?.Record?.Country && (
                                <>
                                    <div className={styles.staticText}>{t("record_country")}</div>
                                    {Array.isArray(record?.data?.Record?.Country)
                                        ? record?.data?.Record?.Country[0]?.Term ?? ''
                                        : record?.data?.Record?.Country?.Term ?? ''
                                    }
                                </>
                            )}
                        </div>
                    )}
                </div>
            </a>
        </div>
    );

});

export default RecordIconScroll;
